import { AuthenticationAPI } from './authentication.js'
import { COUNTRY_SWEDEN_ID, COUNTRY_UAE_ID, ROOT_URL } from './constants.js'
import fetcher from './fetcher.js'
import { searchParamsFromObject } from './utils.js'

class SocializeAPI {
  static connectedToKinds() {
    return {
      NONE: 0,
      PORTFOLIO: 1,
      TRANSACTION: 2,
      INSTRUMENT: 3,
      GROUP: 4,
      COMMENT: 5,
      PUBLICATION: 6,
      EDITORIAL_CONTENT: 7,
    }
  }
  static getEntityKey(connectedToKind) {
    switch (connectedToKind) {
      case SocializeAPI.connectedToKinds().PORTFOLIO:
        return 'portfolio'
      case SocializeAPI.connectedToKinds().TRANSACTION:
        return 'transaction'
      case SocializeAPI.connectedToKinds().INSTRUMENT:
        return 'instrument'
      case SocializeAPI.connectedToKinds().GROUP:
        return 'group'
      case SocializeAPI.connectedToKinds().COMMENT:
        return 'comment'
      case SocializeAPI.connectedToKinds().PUBLICATION:
        return 'publication'
      case SocializeAPI.connectedToKinds().EDITORIAL_CONTENT:
        return 'editorial_content'
      default:
        return 'none'
    }
    
  }
  static connectedToKindsAppStructure() {
    return {
      'portfolios': {
        'portfolio': SocializeAPI.connectedToKinds().PORTFOLIO,
        'transaction': SocializeAPI.connectedToKinds().TRANSACTION,
      },
      'market': {
        'instrument': SocializeAPI.connectedToKinds().INSTRUMENT,
      },
      'socialize': {
        'group': SocializeAPI.connectedToKinds().GROUP,
        'comment': SocializeAPI.connectedToKinds().COMMENT,
      },
      'publications': {
        'publication': SocializeAPI.connectedToKinds().PUBLICATION,
        'editorialcontent': SocializeAPI.connectedToKinds().EDITORIAL_CONTENT,
      },
    }
  }

  static getConnectedToKind(appName, modelName) {
    const appStructure = SocializeAPI.connectedToKindsAppStructure()
    return appStructure[appName]?.[modelName]
  }
}

class ThreadAPI {

  static connectedToKinds() {
    return SocializeAPI.connectedToKinds()
  }

  static async create(inputData) {
    const url = `${ROOT_URL}/api/v1/socialize/threads/create/`
    const payload = {
      app_name: inputData.appName,
      model_name: inputData.modelName,
      entity_id: inputData.entityId,
      content: inputData.content
    }
    const res = await AuthenticationAPI.post(url, payload)
    const data = await res.json()
    return data
  }

  static async getList({ country_id = COUNTRY_UAE_ID, offset = 0, limit = '', is_default_transaction_thread = 'true' }) {
    const params = searchParamsFromObject({ country_id, offset, limit, is_default_transaction_thread }).toString();
    let url = ''
    url = `${ROOT_URL}/api/v1/socialize/threads/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }

  static async getInstrumentPublicationList({ instrument_id, offset = 0, limit = '', country_id = COUNTRY_UAE_ID}) {
    const connected_to_kind = ThreadAPI.connectedToKinds().PUBLICATION
    const params = searchParamsFromObject({
      connected_to_kind,
      instrument_id,
      offset,
      limit,
      country_id,
    }).toString();
    let url = ''
    url = `${ROOT_URL}/api/v1/socialize/threads/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }


  static async getItem(identifier) {
    const params = searchParamsFromObject({ identifier }).toString();
    let url = ''
    url = `${ROOT_URL}/api/v1/socialize/threads/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    const item = data[0]
    return item;
  }

  static async getConnectedToStockList({ offset = 0, limit = 10 }) {
    const connectedToInstrumentKind = ThreadAPI.connectedToKinds().INSTRUMENT
    const params = searchParamsFromObject({
      connected_to_kind: connectedToInstrumentKind,
      offset,
      limit,
      is_default_transaction_thread: 'false'
    }).toString();
    let url = ''
    url = `${ROOT_URL}/api/v1/socialize/threads/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }

  static async getConnectedToPortfolioList({ offset = 0, limit = '' }) {
    const connectedToInstrumentKind = ThreadAPI.connectedToKinds().PORTFOLIO
    const params = searchParamsFromObject({
      connected_to_kind: connectedToInstrumentKind,
      offset,
      limit,
      is_default_transaction_thread: 'false'
    }).toString();
    let url = ''
    url = `${ROOT_URL}/api/v1/socialize/threads/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }

  static async getConnectedToTransactionList({ offset = 0, limit = '' }) {
    const connectedToInstrumentKind = ThreadAPI.connectedToKinds().TRANSACTION
    const params = searchParamsFromObject({
      connected_to_kind: connectedToInstrumentKind,
      offset,
      limit,
      is_default_transaction_thread: 'true'
    }).toString();
    let url = ''
    url = `${ROOT_URL}/api/v1/socialize/threads/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }

  static async getConnectedToPublicationList({ country_id=COUNTRY_UAE_ID, offset = 0, limit = 10, instrument_id = '' }) {
    const connectedToInstrumentKind = ThreadAPI.connectedToKinds().PUBLICATION
    const params = searchParamsFromObject({
      connected_to_kind: connectedToInstrumentKind,
      country_id,
      offset,
      limit,
      instrument_id,
      is_default_transaction_thread: 'false'
    }).toString();
    let url = ''
    url = `${ROOT_URL}/api/v1/socialize/threads/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }

  static async getPortfolioThreadList({ portfolio_id, offset = 0, limit = '' }) {
    const params = searchParamsFromObject({ portfolio_id, offset, limit }).toString();
    let url = ''
    url = `${ROOT_URL}/api/v1/socialize/threads/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }

  static async getPortfolioThreadWallList({ portfolio_id, offset = 0, limit = '' }, is_default_transaction_thread = 0) {
    const params = searchParamsFromObject({
      portfolio_id,
      offset,
      limit,
      is_default_transaction_thread
    }).toString();
    let url = ''
    const uri = '/api/v1/socialize/threads/search'
    url = `${ROOT_URL}${uri}/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }

  static async getInstrumentWallThreadList({ country_id=COUNTRY_UAE_ID, instrument_id, offset = 0, limit = '', is_default_transaction_thread = 0 }) {
    const params = searchParamsFromObject({
      instrument_id,
      offset,
      limit,
      is_default_transaction_thread,
      country_id,
    }).toString();
    let url = ''
    const uri = '/api/v1/socialize/threads/search'
    url = `${ROOT_URL}${uri}/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }

  static connectedToKindToString(kind) {
    const kinds = ThreadAPI.connectedToKinds()
    const kindMap = {
      [kinds.NONE]: 'none',
      [kinds.PORTFOLIO]: 'portfolio',
      [kinds.TRANSACTION]: 'transaction',
      [kinds.INSTRUMENT]: 'instrument',
      [kinds.GROUP]: 'group',
      [kinds.USER]: 'user',
    }
    return kindMap[kind]
  }
}

class CommentAPI {
  static async create(threadId, content) {
    const url = `${ROOT_URL}/api/v1/socialize/comments/${threadId}/create/`
    const payload = {
      content: content
    }
    const res = await AuthenticationAPI.post(url, payload, 0)
    const data = await res.json()
    return data
  }
}

class BookmarkAPI {
  static EMOTIONS = {
    DEFAULT: 0,
    LIKE: 1,
    LOVE: 2,
    HAHA: 3,
    WOW: 4,
    SAD: 5,
    ANGRY: 6,
  }

  static connectedToKinds() {
    return SocializeAPI.connectedToKinds()
  }

  static async create({appName, modelName, entityId, emotionId}) {
    const url = `${ROOT_URL}/api/v1/socialize/bookmarks/`
    const payload = {
      app_name: appName,
      model_name: modelName,
      entity_id: entityId,
      emotion: emotionId,
    }
    const res = await AuthenticationAPI.post(url, payload, 0)
    const data = await res.json()
    return data
  }

  static async getList() {
    const url = `${ROOT_URL}/api/v1/socialize/bookmarks/`
    const res = await AuthenticationAPI.get(url)
    const data = await res.json()
    return data
  }

  static async getForEntity({appName, modelName, entityId}) {
    const url = `${ROOT_URL}/api/v1/socialize/bookmarks/entity/${appName}/${modelName}/${entityId}/`
    const res = await fetcher(url, null, 15*60)
    const data = await res.json()
    return data
  }
}

export { ThreadAPI, CommentAPI, BookmarkAPI, SocializeAPI }